var chunkToChildrenMap = {
	"478": [
		450,
		39,
		890,
		634
	],
	"999": [
		352,
		686
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));